import { defineStore } from 'pinia';
import { useApiClientStore } from './apiClientStore';
import { CompetitionFilter, ICompetition } from '@cyber-range/cyber-range-api-ctf-competition-client';
import { usePlayerStore } from './playerStore';
import { Player } from '@cyber-range/cyber-range-api-ctf-player-client';
import { useAuthenticationStore } from './authenticationStore';
import { useSessionStore } from './sessionStore';

export const useCompetitionStore = defineStore('competitionStore', 
{
    state: () =>
    ({
        currentCompetition: {} as ICompetition
    }),

    actions: 
    {
        async fetchCompetition(payload: {subdomain: string, background?: boolean}): Promise<ICompetition|undefined> 
        {
            let client = payload.background ? useApiClientStore().backgroundCompetitionApiClient : useApiClientStore().competitionApiClient;
            let page = await client.get(new CompetitionFilter(<CompetitionFilter>{subdomain: payload.subdomain}));

            if(page.items.length > 0)
            {
                if(this.currentCompetition?.subdomain !== payload.subdomain)
                {
                    let competition = await client.getOne(page.items[0].id);
                    this.currentCompetition = competition;   
                }
                return page.items[0];
            }
            return undefined;
        },

        async joinCompetition(): Promise<void>
        {
            const identity = useSessionStore().identity;
            if (!identity)
            {
                return;
            }
            
            await usePlayerStore().createPlayer(new Player({
                competitionId: this.currentCompetition.id,
                userId: identity.id,
                name: identity.name,
                email: identity.email
            }));
        },
    }
});